export const getGeneralSearchUrl = (query: string) => {
    return `/search?q=${ query }`;
    /*
    const abtest = getABTest('SearchKentVsSQL');
    if(abtest && abtest.isActive && abtest.selected === 'sql') {
        return `/explore?q=${ query }`;
    }
    else{
        return `/search?searchmode=anyword&smartsearchfilter=0;&searchtext=${ query }`;
    }*/
};